module.exports = __webpack_public_path__ + "static/media/uz.f32eacef.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/uz.svg
// module id = 1010
// module chunks = 0